export default function Machines_C_6 (number = 1) {
  return {
    name: '原油精炼厂',
    icon: '/static/img/machines/c6.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_6.js